import React from "react";
import { Landmark, CreditCard, Upload, GitMerge, Check, ChevronRight } from "lucide-react";

const STEPS = [
  { key: "bank", n: 1, title: "Compte bancaire", desc: "Indiquez la banque dont vous importez les relevés (facultatif).", icon: Landmark },
  { key: "stripe", n: 2, title: "Connecter Stripe", desc: "Encaissez vos factures en ligne et importez vos paiements Stripe (facultatif).", icon: CreditCard },
  { key: "import", n: 3, title: "Importer un relevé", desc: "Déposez le CSV, OFX ou QIF téléchargé depuis votre banque.", icon: Upload },
  { key: "match", n: 4, title: "Rapprocher", desc: "Validez les correspondances proposées avec vos factures et avoirs.", icon: GitMerge },
];

// Phase 66 — parcours guidé en 4 étapes (cliquer sur une étape fait défiler vers sa section)
export function RecoSteps({ steps, current, onSelect }) {
  const state = Object.fromEntries((steps || []).map((s) => [s.key, s]));
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="reco-steps">
      {STEPS.map((s, i) => {
        const st = state[s.key] || {};
        const active = current === s.key;
        return (
          <button key={s.key} type="button" onClick={() => onSelect(s.key)} data-testid={`reco-step-${s.key}`} aria-current={active}
            className={`relative text-left p-4 border transition-colors ${active ? "border-[#002FA7] bg-[#EFF3FF]" : st.done ? "border-[#059669]/40 bg-white hover:border-[#0A0A0A]" : "border-[#DEE2E6] bg-white hover:border-[#0A0A0A]"}`}>
            <div className="flex items-center justify-between">
              <span className={`inline-flex items-center justify-center h-7 w-7 text-xs font-black ${st.done ? "bg-[#059669] text-white" : active ? "bg-[#002FA7] text-white" : "bg-[#0A0A0A] text-white"}`} data-testid={`reco-step-badge-${s.key}`}>{st.done ? <Check className="h-4 w-4" /> : s.n}</span>
              <s.icon className={`h-4 w-4 ${active ? "text-[#002FA7]" : "text-[#868E96]"}`} />
            </div>
            <div className="mt-3 text-sm font-bold flex items-center gap-1">{s.title}{st.optional && <span className="text-[9px] uppercase tracking-wider font-bold text-[#868E96] ml-1">facultatif</span>}</div>
            <div className="text-[11px] text-[#495057] mt-0.5 leading-snug">{s.desc}</div>
            {i < STEPS.length - 1 && <ChevronRight className="hidden lg:block absolute -right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#DEE2E6]" />}
          </button>
        );
      })}
    </div>
  );
}
